import moment from "moment";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { backendDateFormat, fieldDateFormat } from "../../../constants";

const monthYearFormat = "MM-YYYY";

export const StartDateFilter = ({reportData,onFieldChange,onFocusChange = () => {},error = {},isFutureDisabled,isRequired = true,monthYearOnly = false}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DatePicker
        label="Start Date"
        value={reportData?.start_date ? moment(reportData.start_date) : null}
        onChange={(data) => {
          const isValid = moment(data)?.isValid();
          const formattedDate = isValid ? (monthYearOnly ? moment(data).startOf("month") : moment(data)).format(backendDateFormat) : null;
          onFieldChange("start_date", formattedDate);
          if (isValid) { onFocusChange("start_date"); onFocusChange("end_date"); }
        }}
        disableFuture={isFutureDisabled}
        {...(monthYearOnly ? { views: ["month", "year"], openTo: "month" } : {})}
        slotProps={{
          textField: {
            InputLabelProps: { shrink: true },
            size: "small",
            margin: "normal",
            required:isRequired,
            helperText: error.start_date,
            error: !!error.start_date,
            onFocus: () => onFocusChange("start_date")
          },
        }}
        sx={{ width: "100%" }}
        format={monthYearOnly ? monthYearFormat : fieldDateFormat}
      />
    </LocalizationProvider>
  )
}

export const EndDateFilter = ({reportData,onFieldChange,onFocusChange = () => {},error = {},disabled,isRequired = true,monthYearOnly = false}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DatePicker
        label="End Date"
        value={reportData?.end_date ? moment(reportData.end_date) : null}
        onChange={(data) => {
          const isValid = moment(data)?.isValid();
          const formattedDate = isValid ? (monthYearOnly ? moment(data).endOf("month") : moment(data)).format(backendDateFormat) : null;
          onFieldChange("end_date", formattedDate);
          if (isValid) { onFocusChange("end_date"); }
        }}
        disableFuture
        disabled={disabled}
        {...(monthYearOnly ? { views: ["month", "year"], openTo: "month" } : {})}
        minDate={ reportData?.start_date ? moment(reportData.start_date) : undefined }
        slotProps={{
          textField: {
            InputLabelProps: { shrink: true },
            size: "small",
            margin: "normal",
            required:isRequired,
            helperText: error.end_date,
            error: !!error.end_date,
            onFocus: () => onFocusChange("end_date"),
            // disabled : disabled
          },
        }}
        sx={{ width: "100%" }}
        format={monthYearOnly ? monthYearFormat : fieldDateFormat}
      />
    </LocalizationProvider>
  )
}